import React from "react"
import { Modal } from "@mimber/ui-web"
import { CancelEventForm } from "@/components/forms/CancelEventForm"
import type { CancelEventModalProps } from "./CancelEventModal.types"

export const CancelEventModal: React.FunctionComponent<
  CancelEventModalProps
> = ({ event, onSuccess, ...modalProps }) => {
  return (
    <Modal title="Cancel Event" footer={null} {...modalProps}>
      {(close) => (
        <CancelEventForm
          event={event}
          onSuccess={() => {
            onSuccess?.()
            close()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
